module.exports = __webpack_public_path__ + "640bb447d9d15ef086a454fcf840a595.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pencil.png
// module id = 2085
// module chunks = 0